module.exports = __webpack_public_path__ + "img/role02.ade3ec66.png";